import { nodeListToArray } from '../helpers/nodeListToArray';

const PREVENT_DOUBLE_SUBMIT_ATTRIBUTE = 'data-prevent-double-submit';
const SUBMITTING_CLASS = 'is-submitting';
const DISABLED_BUTTON_CLASS = 'disabled';
const SUBMIT_BUTTON_SELECTOR = 'input[type="submit"], button[type="submit"], button:not([type])';

/* preventDoubleSubmit guards every form marked with the data-prevent-double-submit attribute against
repeated submissions: the first submit flags the form and disables its submit buttons (native
disabled attribute + the project's .disabled class for the grey/opacity visual). The CSS override in
_buttons.scss scoped to form.is-submitting keeps the .disabled class from forcing display: flex and
a fixed height on the button, so layout is preserved. The guard relies on the native submit event,
so it does not cover buttons wired into the disable-button validation flow (form-validation.ts),
which submits programmatically via HTMLFormElement.submit() and never raises the submit event. */
export function preventDoubleSubmit() {
    const forms = nodeListToArray(document.querySelectorAll(`form[${PREVENT_DOUBLE_SUBMIT_ATTRIBUTE}]`)) as HTMLFormElement[];

    if (forms.length === 0) {
        return;
    }

    forms.forEach(form => {
        form.addEventListener('submit', (e: Event) => {
            if (form.classList.contains(SUBMITTING_CLASS)) {
                e.preventDefault();
                return;
            }

            form.classList.add(SUBMITTING_CLASS);
            getSubmitButtons(form).forEach(button => {
                button.disabled = true;
                button.classList.add(DISABLED_BUTTON_CLASS);
            });
        });
    });

    // Pages restored from the back/forward cache keep their DOM state, so the
    // buttons would stay disabled after navigating back without this reset.
    window.addEventListener('pageshow', (e: Event) => {
        if (!(e as any).persisted) {
            return;
        }

        forms.forEach(form => {
            form.classList.remove(SUBMITTING_CLASS);
            getSubmitButtons(form).forEach(button => {
                button.disabled = false;
                button.classList.remove(DISABLED_BUTTON_CLASS);
            });
        });
    });
}

function getSubmitButtons(form: HTMLFormElement): HTMLInputElement[] {
    return nodeListToArray(form.querySelectorAll(SUBMIT_BUTTON_SELECTOR));
}
